/* globals request */
import API_URL_MAP from '../configs/url-api';

export default class Payment {
  static pay(paymentData = {}) {
    const url = API_URL_MAP.PAID_SERVICES + API_URL_MAP.PAY;
    return request(url, {
      method: 'POST',
      body: paymentData,
      auth: 'Bearer',
    });
  }

  static secure3dCallback(secureCallbackData = {}) {
    const url = API_URL_MAP.PAID_SERVICES + API_URL_MAP.PAY + API_URL_MAP.SECURE_3D_CALLBACK;
    return request(url, {
      method: 'POST',
      body: secureCallbackData,
      auth: 'Bearer',
    });
  }

  static requestSetCheck(paymentData, formData) {
    const url = API_URL_MAP.PAID_SERVICES + API_URL_MAP.REQUEST_SET_CHECK;
    const body = formData ? paymentData : {...paymentData};
    return request(url, {
      method: 'POST',
      auth: 'Bearer',
      body,
    });
  }
}
